import React from 'react';
import Radium from 'radium';

import styles from './MainTextStyle';

import text from '../../text.js';

class MainText extends React.Component{
    render() {
        return (
            <div className="text-center" style={styles.explainerText}>
                <h1>{text.mainTextShort}</h1>
                <p style={styles.subExplanation} className="text-center">
                    {text.mainTextDescription}
                </p>
            </div>
        );
    }
}

export default Radium(MainText);



// WEBPACK FOOTER //
// ./src/components/MainText/MainText.js